// Fetch Request
import fetch from '../../../core/fetch';
import history from '../../../core/history';
import showToaster from '../../../helpers/toasterMessages/showToaster';

async function submit(values, dispatch) {
  if (values.content == null || values.content == '<p><br></p>' || values.content == '<p> </p>') {
    showToaster({ messageId: 'addContent', toasterType: 'error' })
  }
  else {

    const mutation = `
  mutation updateBlogDetails(
    $id: Int,
    $metaTitle: String,
    $metaTitle_en: String,
    $metaTitle_fr: String,
    $metaTitle_it: String,
    $metaTitle_pt: String,
    $metaDescription: String,
    $metaDescription_en: String,
    $metaDescription_fr: String,
    $metaDescription_it: String,
    $metaDescription_pt: String,
    $pageUrl: String,
    $pageTitle: String,
    $pageTitle_en: String,
    $pageTitle_fr: String,
    $pageTitle_it: String,
    $pageTitle_pt: String,
    $content: String,
    $content_en: String,
    $content_fr: String,
    $content_it: String,
    $content_pt: String,
    $footerCategory: String,
  ) {
    updateBlogDetails(
      id: $id,
      metaTitle: $metaTitle,
      metaTitle_en: $metaTitle_en,
      metaTitle_fr: $metaTitle_fr,
      metaTitle_it: $metaTitle_it,
      metaTitle_pt: $metaTitle_pt,
      metaDescription: $metaDescription,
      metaDescription_en: $metaDescription_en,
      metaDescription_fr: $metaDescription_fr,
      metaDescription_it: $metaDescription_it,
      metaDescription_pt: $metaDescription_pt,
      pageUrl: $pageUrl,
      pageTitle: $pageTitle,
      pageTitle_en: $pageTitle_en,
      pageTitle_fr: $pageTitle_fr,
      pageTitle_it: $pageTitle_it,
      pageTitle_pt: $pageTitle_pt,
      content: $content,
      content_en: $content_en,
      content_fr: $content_fr,
      content_it: $content_it,
      content_pt: $content_pt,
      footerCategory: $footerCategory
    ) {
        status
    }
  }
  `;

    const resp = await fetch('/graphql', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        query: mutation,
        variables: values
      }),
      credentials: 'include',
    });

    const { data } = await resp.json();


    if (data.updateBlogDetails.status === "success") {
      showToaster({ messageId: 'updateBlogSuccess', toasterType: 'success' })
      history.push('/siteadmin/content-management');
    }
    else if (data.updateBlogDetails.status === 'URL exist') {
      showToaster({ messageId: 'addBlogFailed', toasterType: 'error' })
    }
    else {
      showToaster({ messageId: 'failedToUpdateBlog', toasterType: 'error' })
    }
  }

}

export default submit;
